module.exports = __webpack_public_path__ + "img/img_C3.12.4.1453b7f5.png";